import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69e3ed37"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "request-account-result-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_my_icon = _resolveComponent("my-icon")!
  const _component_k_button = _resolveComponent("k-button")!
  const _component_dialog_actions_bar = _resolveComponent("dialog-actions-bar")!
  const _component_app_dialog = _resolveComponent("app-dialog")!

  return (_openBlock(), _createBlock(_component_app_dialog, {
    title: _ctx.localize(_ctx.isSuccess ? 'success' : 'failure'),
    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_my_icon, {
          icon: _ctx.isSuccess ? 'check' : 'warning',
          color: _ctx.isSuccess ? 'var(--color-green)' : 'var(--color-red)',
          size: 56
        }, null, 8, ["icon", "color"]),
        _createElementVNode("p", null, _toDisplayString(_ctx.localize(_ctx.isSuccess ? 'requestAccountSuccessBody' : 'requestAccountFailureBody')), 1)
      ]),
      _createVNode(_component_dialog_actions_bar, null, {
        default: _withCtx(() => [
          _createVNode(_component_k_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.localize('close')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title"]))
}